(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations', [
        'bmHttpUtils',
        'bluemoon.components.session',
        'pascalprecht.translate',
        'bmTranslateEventUtils',
        'ui.router',
        'wj',
        'ui.bootstrap',
        'bento.modern.ui',
        'bento.progressbar',
        'bento.pagination',
        'bento.services',
        'bento.transferbox',
        'bmpConfirmationDialog',
        'bmpFlexGridSetUpFactory'
    ])
    .constant('migrationApps', {
        fileCabinet: 'file-cabinet',
        migrationHomeUrl: '/setup/migrations',
        loadItemSetTimeout: 120000,
        loadItemSetPoolingGap: 10000,
        utilityWinTimeout: 60000,
        uploadingDeadTimeoutMM:30,
        utilityUrl: 'onvio:test?'
    })
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('setup-migrations-new', {
            url: '/setup/migrations/new',
            templateUrl: 'setup/src/migrations/new-migration/new-main.2js.html',
            controller: 'onvio.setup.migrations.NewMigrationMainController as vm',
            resolve: {
                'resolve.translationsLoaded': ['bmTranslateEventUtils', function(bmTranslateEventUtils) {
                    return bmTranslateEventUtils.loadEnd();
                }],
                migrationConfig:['migrationService', function(migrationService) {
                        return migrationService.getMigrationConfig();
                }]
            }
        });

        $stateProvider.state('setup-migrations-file-cabinet-new', {
            url: '/setup/migrations/file-cabinet/new',
            templateUrl: 'setup/src/migrations/file-cabinet/migration-creation/creation-main.2js.html',
            controller: 'onvio.setup.migrations.fileCabinet.MigrationCreationMainController as vm',
            resolve: {
                'resolve.translationsLoaded': ['bmTranslateEventUtils', function(bmTranslateEventUtils) {
                    return bmTranslateEventUtils.loadEnd();
                }],
                migrationConfig:['migrationService', function(migrationService) {
                        return migrationService.getMigrationConfig();
                }]
            }
        });

    }]);

})(window.angular);
